import type { WsfeCertificadoInfo } from '../services/wsfeConfigService';

/** Días restantes a partir de los cuales se avisa a administradores / panel ARCA. */
export const DIAS_AVISO_POR_VENCER = 30;

export function formatFechaCertificado(fecha?: string | null): string {
  const f = (fecha ?? '').trim();
  if (!f) return '';
  const d = new Date(f);
  if (Number.isNaN(d.getTime())) return f;
  return d.toLocaleDateString('es-AR');
}

export function certRequiereAviso(info: WsfeCertificadoInfo, diasAviso = DIAS_AVISO_POR_VENCER): boolean {
  return info.vencido || info.diasParaVencer <= diasAviso;
}

export function labelVigenciaCert(info: WsfeCertificadoInfo, diasAviso = DIAS_AVISO_POR_VENCER): string {
  if (info.vencido) return 'Vencido';
  if (info.diasParaVencer <= diasAviso) {
    return info.diasParaVencer <= 0
      ? 'Vence hoy'
      : `Vence en ${info.diasParaVencer} día${info.diasParaVencer === 1 ? '' : 's'}`;
  }
  const hasta = formatFechaCertificado(info.validoHasta);
  return hasta ? `Vence el ${hasta}` : 'Vigente';
}

export function severityVigenciaCert(
  info: WsfeCertificadoInfo,
  diasAviso = DIAS_AVISO_POR_VENCER
): 'error' | 'warning' | 'success' {
  if (info.vencido) return 'error';
  if (info.diasParaVencer <= diasAviso) return 'warning';
  return 'success';
}
